/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMasonryLayout = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 17v6H1v-6zm7 0v6H8v-6zm9 0v6h-8v-6zM5 19H3v2h2zm7 0h-2v2h2zm9 0h-4v2h4zm2-11v8H8V8zM7 8v8H1V8zm14 2H10v4h11zM5 10H3v4h2zm18-9v6h-6V1zm-7 0v6h-6V1zM9 1v6H1V1zm12 2h-2v2h2zm-7 0h-2v2h2zM7 3H3v2h4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMasonryLayout as MasonryLayout };
